export const extractFilename = (contentDisposition: string): string => {
  const match = contentDisposition.match(
    /filename\*?=(?:UTF-8'')?["']?(.+?)["']?(?:;|$)/i
  )
  if (!match) return 'plik.docx'

  // Usuwa katalogi jeśli są (np. 4/umowa_...)
  const fullFilename = match[1].trim()
  const onlyFilename = fullFilename.split('/').pop() || 'umowa.docx'
  return onlyFilename
}
